var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hide-overflow-x",attrs:{"id":"mainDiv","data-spy":"scroll","data-offset":"80"}},[_c('Loader'),_vm._v(" "),_c('HeaderStyle1',{attrs:{"id":"header","logo-img":_vm.logo,"nav-item-list":_vm.navItems,"styled-logo":_vm.styleLogo}}),_vm._v(" "),_c('nuxt')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('ScrollTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }